/**
 * THE MOUNT. One root, one router, and nothing else.
 *
 * The stylesheet is linked from index.html rather than imported here, so the
 * page has its ground, its type and its density before the first component
 * mounts — and so exactly one copy of it exists.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./screens/app.js";
import { ClientRequestPage } from "./screens/clientRequest.js";

/**
 * A CLIENT'S REQUEST LINK (`/r#<token>`, R10.1) is decided here, before the app
 * mounts: the client has no account, so the sign-in gate — and its session
 * call — must never stand between them and the one request they were sent.
 */
createRoot(document.getElementById("root")!).render(
  window.location.pathname === "/r" ? (
    <ClientRequestPage />
  ) : (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
);
